import { PublicPage } from 'api/website';

type Props = {
  content: PublicPage;
};

export function getContentShowListingCounts({ content }: Props): boolean {
  return Boolean(
    content && content.heroSearch && content.heroSearch.showCounts
  );
}
